import { EmptyState as PolarisEmptyState } from '@shopify/polaris';
import { ReactNode } from 'react';

export interface EmptyStateProps {
  heading: string;
  children?: ReactNode;
  action?: { content: string; onAction: () => void };
}

export function EmptyState({ heading, children, action }: EmptyStateProps): JSX.Element {
  return (
    <PolarisEmptyState
      heading={heading}
      image=""
      action={action}
    >
      {children}
    </PolarisEmptyState>
  );
}
